module.exports = __webpack_public_path__ + "static/img/addApply.f6439fef.png";